const fillEmptyCategory = ({series}) => {
    const fillEmptyDataCat = (data) => data.map((d) => [!d[0] ? "null" : d[0], d[1]]);

    return series.map((s) => ({
        ...s,
        data: fillEmptyDataCat(s.data),
    }));
};
exports.fillEmptyCategory = fillEmptyCategory;
